import { TestWebhookRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

export default function useTestWebhook() {
  const api = useApi();

  async function testWebhook(params: TestWebhookRequest) {
    try {
      const res = await api.fetchTestWebhook(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { testWebhook };
}
